import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AlertsOverview from 'components/DataPanel/Overview/Alerts';
import RoutesOverview from 'components/DataPanel/Overview/Routes';
import SegmentsOverview from 'components/DataPanel/Overview/Segments';
import LocationsOverview from 'components/DataPanel/Overview/Locations';

import SegmentDetails from 'components/DataPanel/Details/Segment';
import LocationDetails from 'components/DataPanel/Details/Location';
import RouteDetails from 'components/DataPanel/Details/Route';
import Settings from 'components/MapPanel/Settings';

import CreateSegment from 'components/MapPanel/CreateSegment';
import CreateRoute from 'components/MapPanel/CreateRoute';

import LiveMap from 'components/Map/Live';
import CreateSegmentMap from 'components/Map/CreateSegment';
import CreateRouteMap from 'components/Map/CreateRoute';

import App from 'containers/App';

// Webpack 2 supports ES2015 `import` by auto-
// chunking assets. Check out the following for more:
// https://gist.github.com/sokra/27b24881210b56bbaff7#code-splitting-with-es6

const handleChunkError = cb => err => {
  // eslint-disable-next-line no-console
  console.error(err);
  cb(err);
};

const importHome = (nextState, cb) => {
  import(/* webpackChunkName: "home" */ 'containers/Home')
    .then(module => cb(null, module.default))
    .catch(handleChunkError(cb));
};

const importMapLayout = (nextState, cb) => {
  import(/* webpackChunkName: "map" */ 'components/Map/Layout')
    .then(module => cb(null, module.default))
    .catch(handleChunkError(cb));
};

const importUser = (nextState, cb) => {
  import(/* webpackChunkName: "user" */ 'containers/User')
    .then(module => cb(null, module.default))
    .catch(handleChunkError(cb));
};

const importNotFound = (nextState, cb) => {
  import(/* webpackChunkName: "notFound" */ 'containers/NotFound')
    .then(module => cb(null, module.default))
    .catch(handleChunkError(cb));
};

// We use `getComponent` to dynamically load routes.
// https://github.com/reactjs/react-router/blob/master/docs/guides/DynamicRouting.md
const routes = (
  <Route path="/" component={App}>
    <IndexRoute getComponent={importHome} />

    <Route path="map/live" getComponent={importMapLayout}>
      {/*
        We pass content on a per section basis. Currently overview and
        detail are seperated because they use different layouts and the
        one for Overview needs to be shared and not remount on url change. This
        can be made better / cleaner probably but first priority is to make it work.
        */}
      <IndexRoute
        components={{
          main: LiveMap,
          mapPanel: Settings,
        }}
      />

      <Route
        path="locations"
        components={{
          main: LiveMap,
          dataPanelOverview: LocationsOverview,
          mapPanel: Settings,
        }}
      />
      <Route
        path="segments"
        components={{
          main: LiveMap,
          dataPanelOverview: SegmentsOverview,
          mapPanel: Settings,
        }}
      />
      <Route
        path="routes"
        components={{
          main: LiveMap,
          dataPanelOverview: RoutesOverview,
          mapPanel: Settings,
        }}
      />
      <Route
        path="alerts"
        components={{
          main: LiveMap,
          dataPanelOverview: AlertsOverview,
          mapPanel: Settings,
        }}
      />
      <Route
        path="locations/:id"
        components={{
          main: LiveMap,
          dataPanelDetails: LocationDetails,
          mapPanel: Settings,
        }}
      />
      <Route
        path="segments/:id"
        components={{
          main: LiveMap,
          dataPanelDetails: SegmentDetails,
          mapPanel: Settings,
        }}
      />
      <Route
        path="routes/:id"
        components={{
          main: LiveMap,
          dataPanelDetails: RouteDetails,
          mapPanel: Settings,
        }}
      />
    </Route>
    <Route path="map/create" getComponent={importMapLayout}>
      <Route
        path="route"
        components={{
          main: CreateRouteMap,
          mapPanel: CreateRoute,
        }}
      />
      <Route
        path="segment"
        components={{
          main: CreateSegmentMap,
          mapPanel: CreateSegment,
        }}
      />
    </Route>

    <Route path="segments/:id" component={() => <div />} />
    <Route path="routes/:id" component={() => <div />} />
    <Route path="devices/:id" component={() => <div />} />
    <Route path="user" getComponent={importUser} />
    <Route path="*" getComponent={importNotFound} status={404} />
  </Route>
);

// Unfortunately, HMR breaks when we dynamically resolve
// routes so we need to require them here as a workaround.
// https://github.com/gaearon/react-hot-loader/issues/288

/* istanbul ignore if */
if (module.hot) {
  require('containers/Home'); // eslint-disable-line global-require
  require('components/Map/Layout'); // eslint-disable-line global-require
  require('containers/User'); // eslint-disable-line global-require
  require('containers/NotFound'); // eslint-disable-line global-require
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js